import InternalRadio from "./Radio";
import Group from "./Group";
var Radio = InternalRadio;
Radio.Group = Group;
export default Radio;